import { console } from 'react-redux-app/lib/modules/core/utils';
import { handleOnEnterException } from 'react-redux-app/lib/modules/routing/utils';

import { INTERNAL_ERROR_URI } from 'react-redux-app/lib/modules/routing/constants';
import { maybeHandleCriticalError } from 'react-redux-app/lib/modules/api/utils';

import { actionLoadSiteBannersExchangeRequest } from '../../actions/loadSiteBannersExchange';

import { getLoadBannersError } from '../../selectors/errors';


export default ({ getState, dispatch }) => (
  function loadSiteBannersExchangeHandler(nextState, successCallback, errorCallback) {
    dispatch(
      actionLoadSiteBannersExchangeRequest(nextState.params.siteId)
    ).then(
      () => {
        if (handleOnEnterException(getState(), errorCallback, INTERNAL_ERROR_URI)) {
          return;
        }

        const error = getLoadBannersError(getState());
        if (
          error
          && maybeHandleCriticalError(nextState.location, error.globalErrors, errorCallback)
        ) {
          return;
        }

        successCallback();
      }
    ).catch(error => {
      console.consoleError('loadSiteBannersExchangeHandler failed', error);
      errorCallback(INTERNAL_ERROR_URI);
    });
  }
);
